const house_sec3Object = (payload) => {
  return {
    type: "housesec3",
    payload,
  };
};

export default house_sec3Object;
